import { Text } from '@/clients/shared-components/Typography';

export function ErrorScreen(props: { message: string }) {
  return (
    <div>
      <Text header bold>
        Something went wrong. Please refresh and try again.
      </Text>
      <code>{props.message}</code>
    </div>
  );
}
